import React from "react";
import classNames from "classnames";
import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import Environment from "../../../../environment";

import QuadriLogo from "../../../../assets/images/quadri.svg";
import ConfigurationLogo from "../../../../assets/images/Configuration.svg";

import styles from "./Header.module.scss";

interface HeaderProps {
  sidebarToggle: () => void;
}

const Header = (props: HeaderProps) => {
  const trimbleIdentityUrl = Environment.identityUrl;
  const privacyPolicyUrl = "https://www.trimble.com/privacy.aspx";
  const termsOfUseUrl = "http://quadri.trimble.com/terms-service";

  return (
    <Navbar expand="md" className="modus-header">
      <a onClick={props.sidebarToggle}>
        <i className="modus-icons menu-btn align-middle">menu</i>
      </a>
      <Navbar.Brand className="mr-auto align-middle d-none d-md-block">
        <img src={ConfigurationLogo} className={styles.configurationLogo} />
      </Navbar.Brand>

      <div className={styles.brandDiv}>
        <Navbar.Brand
          className={classNames("mx-auto", "align-middle", styles.brandIcon)}
        >
          <img src={QuadriLogo} className={styles.headerLogo} />
        </Navbar.Brand>
      </div>

      <Dropdown>
        <Dropdown.Toggle
          id="UserNavDropdown"
          variant="light"
          size="lg"
          className="btn-text-primary"
          bsPrefix="btn-icon-only"
        >
          <i className="modus-icons">user</i>
        </Dropdown.Toggle>
        <Dropdown.Menu alignRight={true}>
          <Dropdown.Item href={trimbleIdentityUrl} target="_blank">
            My Profile
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item href={privacyPolicyUrl} target="_blank">
            Privacy Policy
          </Dropdown.Item>
          <Dropdown.Item href={termsOfUseUrl} target="_blank" disabled={true}>
            Terms of Use
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </Navbar>
  );
};

export default Header;
